import { CopyRightTO } from '@im/ui-lib/types';
import { useApiQuery } from '../query';

type GetCopyRightsResponseTO = {
  items: CopyRightTO[];
};

export function useCopyrightLinks() {
  const query = useApiQuery<GetCopyRightsResponseTO>(
    '/cms/v1/quick-links?type=FooterCopyright'
  );
  return query.data?.items;
}
